import { handleRequest, handleUploadRequest } from '../services/APIService';

export const FETCH_INQUIRIES = 'FETCH_INQUIRIES';
export const FETCH_INQUIRIES_ERROR = 'FETCH_INQUIRIES_ERROR';

export const CHANGE_INQUIRY_STATUS = 'CHANGE_INQUIRY_STATUS';
export const CHANGE_INQUIRY_STATUS_ERROR = 'CHANGE_INQUIRY_STATUS_ERROR';

export const FETCH_INQUIRY_STAFF_COMMENTS = 'FETCH_INQUIRY_STAFF_COMMENTS';
export const FETCH_INQUIRY_STAFF_COMMENTS_ERROR = 'FETCH_INQUIRY_STAFF_COMMENTS_ERROR';

export const ADD_INQUIRY_STAFF_COMMENTS = 'ADD_INQUIRY_STAFF_COMMENTS';
export const ADD_INQUIRY_STAFF_COMMENTS_ERROR = 'ADD_INQUIRY_STAFF_COMMENTS_ERROR';

export const CREATE_INQUIRY_MESSAGE = 'CREATE_INQUIRY_MESSAGE';
export const CREATE_INQUIRY_MESSAGE_ERROR = 'CREATE_INQUIRY_MESSAGE_ERROR';

export const UPLOAD_INQUIRY_ATTACHMENT = 'UPLOAD_INQUIRY_ATTACHMENT';
export const UPLOAD_INQUIRY_ATTACHMENT_ERROR = 'UPLOAD_INQUIRY_ATTACHMENT_ERROR';

export const getAllInquiries = ({ facilityId, params }) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'get',
        `facility/${facilityId}/contact-requests`,
        true,
        {},
        params,
      );

      dispatch({
        type: FETCH_INQUIRIES,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_INQUIRIES_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const getInquiryStaffComments = (contactRequestId) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'get',
        `contact-requests/${contactRequestId}/staff-comments`,
        true,
        {},
      );

      dispatch({
        type: FETCH_INQUIRY_STAFF_COMMENTS,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_INQUIRY_STAFF_COMMENTS_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const addInquiryStaffComments = (
  authorId,
  contactRequestId,
  comment,
) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'put',
        `contact-requests/${contactRequestId}/staff-comments`,
        true,
        {
          authorId,
          comment,
        },
      );

      dispatch({
        type: ADD_INQUIRY_STAFF_COMMENTS,
        payload: results.data,
      });
    } catch (error) {
      dispatch({
        type: ADD_INQUIRY_STAFF_COMMENTS_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const changeInquiryStatus = (contactRequestId, status) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'put',
        `contact-requests/${contactRequestId}/inquiry-status`,
        true,
        { status },
      );

      return dispatch({
        type: CHANGE_INQUIRY_STATUS,
        payload: results.data,
      });
    } catch (error) {
      return dispatch({
        type: CHANGE_INQUIRY_STATUS_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const createInquiryMessage = ({
  contactRequestId,
  message,
  requiresResponse = false,
  attachments = {},
}) => {
  return async (dispatch) => {
    try {
      const results = await handleRequest(
        'post',
        `contact-requests/${contactRequestId}/message`,
        true,
        {
          message,
          requiresResponse,
          attachments,
        },
      );

      return dispatch({
        type: CREATE_INQUIRY_MESSAGE,
        payload: results.data,
      });
    } catch (error) {
      return dispatch({
        type: CREATE_INQUIRY_MESSAGE_ERROR,
        payload: error.response || error,
      });
    }
  };
};

export const uploadInquiryAttachment = (file, type) => {
  return async (dispatch) => {
    try {
      const results = await handleUploadRequest(
        file,
        `contact-requests/${type}`,
      );
      return dispatch({
        type: UPLOAD_INQUIRY_ATTACHMENT,
        payload: { ...results.data, type },
      });
    } catch (error) {
      return dispatch({
        type: UPLOAD_INQUIRY_ATTACHMENT_ERROR,
        payload: error,
      });
    }
  };
};
